<template>
    <div class="booker">
      <h5 class="booker__title">Dati di fatturazione</h5>
      <validation-observer
        v-slot="{ invalid }"
        ref="observer"
      >
        <div
          class="booker__group-input"
          v-for="(field,key) in booker"
          :key="'input_'+key"
        >

          <validation-provider
            :rules="field.rules"
            :name="key"
            :vid="key"
            v-slot="{ errors, validate, failedRules }"
          >
            <label class="vb-label" v-html="field.name" />
            <vb-input
              @input="validate_fields($event,validate,key)"
              @change="validate_fields($event,validate,key)"
              @blur="validate_fields($event,validate,key)"
              v-model="booker[key].value"
              :vb_options="{
                name: key,
              }"
            />
            <div v-for="(rule,index) in failedRules" v-bind:key="_uid+index">
              <span v-if="index!=='required'" class="vee--errors">{{ rule.replace(key, field.name) }}</span>
            </div>

          </validation-provider>

        </div>
      </validation-observer>
    </div>
</template>

<script>
import * as Validation from '@resources/validation'
export default {
  name: 'booker',

  props: {
    validate_on_mount: {
      type: Boolean,
      default: false,
    }
  },

  mounted() {
    if (this.validate_on_mount) {
      let timer = setInterval(() => {
        if (this.$refs.observer) {
          clearInterval(timer)
          this.$refs.observer.validate().then(res => {
            let payload = res ? this.get_payload() : false
            this.emit_results(payload)
          })
        }
      }, 500)
    }
  },

  data() {
    return {
      booker: {
        booker_address: Validation.address,
        booker_city: Validation.city,
        booker_postal_code: Validation.postal_code,
        booker_province: Validation.province,
      }
    }
  },

  watch: {
    booker: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          //setTimeout(() => {
            this.$refs.observer.validate().then(res => {
              let payload = res ? this.get_payload() : false
              this.emit_results(payload)
            })
          //}, 200)
        })
      }
    }
  },

  methods: {
    get_payload() {
      let fields = this.$refs.observer.fields,
          payload = {}
      for (let index = 0; index < Object.keys(fields).length; index++) {
        const key = Object.keys(fields)[index]

        payload = {
          ...payload,
          [key]: this.booker[key].value
        }
      }
      return payload
    },

    async validate_fields(value, validate, name) {
      const { valid } = await validate(value)

      if (!valid) {
        this.emit_results(false)
        return
      }

      const fields = this.$refs.observer.fields

      const all_valid = Object.keys(fields).every(key =>
        key === name || fields[key].valid !== false
      )

      this.emit_results(all_valid ? this.get_payload() : false)
    },

    emit_results(payload) {
      this.$emit('change', {name: 'booker-update', payload: payload})
    },
  }
}
</script>

<style lang="scss">

  .booker {

    &__title {
      @extend %sidebar__title;
    }

    &__group-input {
      @extend %sidebar__group-input;
    }
  }

</style>